module.exports = __webpack_public_path__ + "img/sandra.7c75736d.jpg";